import { PropertyNoteDTO } from "../DTO/propertyNoteDTO";

export class StorePropertyNoteRequest{
    public userId!:string;
    public businessId!:string;
    public propertyNote!:PropertyNoteDTO;
}